export function formatearFechaConHora(fechaIso: string) {
    if (!fechaIso) return "";
    const fecha = new Date(fechaIso);
    return fecha.toLocaleString("es-CL", {...opciones, ...opcionesHora}).replace(",", "");
}

export function formatearFechaSinHora(fechaIso: string) {
    if (!fechaIso) return "";
    const fecha = new Date(fechaIso);
    return fecha.toLocaleDateString("es-CL", opciones);
}

export function obtenerFechaEscrita(fecha: Date): string {
    if (!fecha) return "";
    const meses = [
      'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
      'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
    ];

    const dia = fecha.getDate();
    const mes = meses[fecha.getMonth()];
    const anio = fecha.getFullYear();

    return `${dia} de ${mes} de ${anio}`;
}

export function obtenerHora(fecha: Date): string {
    if (!fecha) return "";
    const hora = fecha.getUTCHours();
    const minutos = fecha.getUTCMinutes();

    return `${hora}:${minutos}`;
}

const opciones: Intl.DateTimeFormatOptions = {
    timeZone: "America/Santiago",
    hour12: false,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
}

const opcionesHora: Intl.DateTimeFormatOptions = {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
}

export function obtenerCantidadDias(fechaPosterior: Date, fechaAnterior: Date) {
    // Setear la hora de las fechas a las 00 hrs
    fechaPosterior.setHours(0, 0, 0, 0);
    fechaAnterior.setHours(0, 0, 0, 0);

    // Calcular diferencia en milisegundos
    const diffMs = fechaPosterior.getTime() - fechaAnterior.getTime();

    // Convertir a días (1 día = 1000 * 60 * 60 * 24 ms)
    return Math.floor(diffMs / (1000 * 60 * 60 * 24));
}

export function obtenerFechaActual(): string {
    const fecha = new Date();
    return fecha.toLocaleDateString("es-CL", opciones);
}

export function obtenerFechaActualConBarras() {
    return obtenerFechaActual().replace(/-/g, "/");
}